"use strict";

var obj = {
  breakpointTiny: '375px',
  breakpointSmall: '544px',
  breakpointMedium: '768px',
  breakpointLarge: '1024px'
};
module.exports = obj;